import { createSlice } from "@reduxjs/toolkit";
import SensorDetails from "types/SensorDetails.type";
import { logout } from "./actions";

type InitialState = {
  datasets: Record<string, SensorDetails[]>;
};

const initialState: InitialState = {
  datasets: {}
};

export const cacheSlice = createSlice({
  name: "cache",
  initialState,
  reducers: {
    cacheDatasets: (state, action) => {
      const groups = {};
      action.payload.forEach((dataset) => {
        if (groups[dataset.sensorLabel]) {
          groups[dataset.sensorLabel].push(dataset);
        } else {
          groups[dataset.sensorLabel] = [dataset];
        }
      });
      Object.keys(groups).forEach((groupKey) => {
        state.datasets[groupKey] = groups[groupKey];
      });
    },
    clearCache: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  }
});
export const { cacheDatasets, clearCache } = cacheSlice.actions;
export default cacheSlice.reducer;
